import config from 'config';

export const getMFImagesLink = () => `${config.app.mfLink}/images/`;
